import { normalize } from "normalizr";
import React from "react";
import { all, call, put, takeEvery } from "redux-saga/effects";

import {
    COMPLAINT_OPEN_TRIGGER,
    COMPLAINT_SEND,
    ComplaintOpenTriggerAction,
    ComplaintSendAction,
    complaintSave,
    complaintToggle,
} from "@/mk2/containers/Complaint/Complaint.actions";
import { saveComplaint as apiSaveComplaint } from "@/mk2/containers/Complaint/Complaint.api";
import { generateFormName } from "@/mk2/containers/Complaint/Complaint.helpers";
import { ComplaintSchema } from "@/mk2/containers/Complaint/Complaint.schemas";
import { XHRAction, XHRFormError, normalizeError } from "@/mk2/helpers/api";
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from "@/mk2/helpers/form";
import { getLogger } from "@/mk2/logger";
import { checkIfUserIsLoggedIn } from "@/mk2/sagas/auth";
import {
    ACTION_TO_REPORT_POST,
    PROBLEM_WAS_REPORTED_THANK_YOU,
} from "@/mk/autogenerated/translation";

const logger = getLogger("Complaint.sagas");

export function* openComplaint({ entity, id, location }: ComplaintOpenTriggerAction) {
    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_REPORT_POST, location))) {
        return;
    }
    yield put(complaintToggle(entity, id, true));
}

export function* saveComplaint({ entity, id, complaint, xhr }: ComplaintSendAction & XHRAction) {
    yield put(complaintSave.request(entity, id, complaint));

    const formName = generateFormName(entity, id);

    try {
        const response = yield call(apiSaveComplaint, xhr, entity, id, complaint);
        const normalizedResponse = normalize(response.body.complaint, ComplaintSchema);
        yield handleXHRFormSuccessSaga(formName, null, null, PROBLEM_WAS_REPORTED_THANK_YOU);
        yield put(complaintSave.success(entity, id, complaint, normalizedResponse));

        // Hide the complaint form
        yield put(complaintToggle(entity, id, false));
    } catch (error) {
        yield handleXHRFormErrorSaga(formName, error as XHRFormError, logger);
        yield put(complaintSave.failure(entity, id, complaint, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeEvery(COMPLAINT_SEND, saveComplaint),
        takeEvery(COMPLAINT_OPEN_TRIGGER, openComplaint),
    ]);
}
